import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getUnreadCount, getNotifications } from "../api/notifications";
import { Bell } from "lucide-react";
import { getLang } from "../store/uiStore";

export default function NotificationBell() {
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);

  const navigate = useNavigate();
  const ref = useRef();
  const lang = getLang();
  const tr = lang === "ru"
    ? {
        title: "Уведомления",
        empty: "Нет уведомлений",
        all: "Все уведомления",
      }
    : {
        title: "Хабарҳо",
        empty: "Хабаре нест",
        all: "Ҳамаи хабарҳо",
      };

  useEffect(() => {
    loadCount();

    // Обновляем счётчик, пока пользователь находится в системе.
    const countInterval = window.setInterval(loadCount, 30000);

    // закрытие при клике вне
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      window.clearInterval(countInterval);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const loadCount = () => {
    getUnreadCount()
      .then((res) => setCount(res.data.count))
      .catch(() => setCount(0));
  };

  const loadNotifications = () => {
    getNotifications().then((res) => {
      setList(res.data.slice(0, 5));
    });
  };

  const toggle = () => {
    setOpen(!open);
    if (!open) {
      loadNotifications();
      loadCount();
    }
  };

  const openAll = () => {
    setOpen(false); // 🔥 закрываем
    navigate("/notifications");
  };

  return (
    <div style={styles.wrapper} ref={ref}>
      <div
        style={styles.icon}
        onClick={toggle}
        onMouseEnter={(e) =>
          (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.background = "transparent")
        }
      >
        <Bell color="white" size={20} />

        {count > 0 && <span style={styles.badge}>{count}</span>}
      </div>

      {open && (
        <div style={styles.dropdown}>
          <div style={styles.header}>{tr.title}</div>

          {list.length === 0 && (
            <div style={styles.empty}>{tr.empty}</div>
          )}

          {list.map((item) => (
            <div
              key={item.id}
              style={{
                ...styles.item,
                background: item.is_read ? "#fff" : "#eef4ff",
              }}
              onClick={() => {
                 setOpen(false); // закрыть dropdown

                // переход
                if (item.url) {
                  // Поддерживаем старые уведомления с прежним URL.
                  const incidentUrl = item.url.match(/(?:\/emergency\/incidents\/|\/api\/incidents\/|\/incidents\/)(\d+)\/?$/);
                  navigate(incidentUrl ? `/incidents/${incidentUrl[1]}` : item.url);
                } else if (
                  item.related_object_type === "incident" &&
                  item.related_object_id
                ) {
                  // Для старых уведомлений без URL используем ID связанного извещения.
                  navigate(`/incidents/${item.related_object_id}`);
                } else {
                  navigate("/notifications");
                }
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#f5f7fa";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = item.is_read
                  ? "#fff"
                  : "#eef4ff";
              }}
            >
              <div
                style={{
                  ...styles.title,
                  color:
                    item.priority === "high"
                      ? "#dc2626"
                      : item.priority === "medium"
                      ? "#f59e0b"
                      : "#111827",
                }}
              >
                {item.title}
              </div>
              <div style={styles.text}>{item.message}</div>
            </div>
          ))}

          <div style={styles.footer} onClick={openAll}>
            {tr.all} →
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  wrapper: {
    position: "relative",
  },
  icon: {
    position: "relative",
    cursor: "pointer",
    padding: "6px",
    borderRadius: "4px",
  },
  bell: {
    fontSize: "18px",
  },
  badge: {
    position: "absolute",
    top: 0,
    right: 0,
    background: "#dc2626",
    color: "#fff",
    borderRadius: "50%",
    fontSize: "11px",
    padding: "2px 6px",
  },
  dropdown: {
    position: "absolute",
    right: 0,
    top: "35px",
    width: "320px",
    background: "#fff",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    zIndex: 1000,
  },
  header: {
    padding: "10px",
    borderBottom: "1px solid #eee",
    fontWeight: "600",
  },
  item: {
    padding: "10px",
    borderBottom: "1px solid #f1f1f1",
    cursor: "pointer",
  },
  title: {
    fontWeight: "600",
    fontSize: "14px",
  },
  text: {
    fontSize: "12px",
    color: "#6b7280",
  },
  empty: {
    padding: "10px",
    textAlign: "center",
    color: "#6b7280",
  },
  footer: {
    padding: "10px",
    textAlign: "center",
    color: "#0b5ea8",
    cursor: "pointer",
    fontWeight: "600",
  },
};
